// for add employee

export const RESET_REMOVE_PERMISSIONS = "reset_remove_permissions";
export const REMOVE_PERMISSIONS = "remove_permissions";
export const REMOVE_PERMISSIONS_SUCCESS = "remove_permissions_success";
export const REMOVE_PERMISSIONS_FAILURE = "remove_permissions_failure";
